import { resolveSelectableComposerModelId } from '@/lib/pieveComposerSettings.js';
import getAutomationItemThreadId from '@/redux/selectors/pieveSelectors/lib/getAutomationItemThreadId.js';

const getAutomationComposerModelId = ({ item, threadMetaByIdValue, fallbackThreadIdToItemId = false }) => {
  const automationThreadId = getAutomationItemThreadId({
    item,
    fallbackToId: fallbackThreadIdToItemId
  });
  const persistedComposerModel = String(item?.composerModel || '').trim();
  const threadComposerModel = String(threadMetaByIdValue?.[automationThreadId]?.composerModel || '').trim();

  return resolveSelectableComposerModelId(persistedComposerModel || threadComposerModel || null);
};

export default getAutomationComposerModelId;
